import React, { createContext, useContext, useEffect, useState } from 'react'
import { Storage, StorageKeys } from '../services/Storage'
import { popElementFromParams } from 'utils/queryParams'
import { useLocationSearch } from 'hooks/useRouter'
import { useFetchEvaluatedDiscount } from 'api/mutations/useFetchEvaluatedDiscount'
import { DiscountBanner } from 'models/Discount'

interface DiscountCodeContextProps {
  discount: DiscountBanner | undefined
  isLoading: boolean
  error: any
  refetchDiscountCode: () => void
}

interface DiscountCodeProviderProps {
  children: React.ReactNode
}

const DiscountCodeContext = createContext<DiscountCodeContextProps | undefined>(undefined)

export const DiscountCodeProvider = ({ children }: DiscountCodeProviderProps) => {
  const search = useLocationSearch()
  const [discount, setDiscount] = useState<DiscountBanner>()
  const storedCode: string | undefined = Storage.get(StorageKeys.PROMO_CODE) ?? undefined
  const promoCodeFromParam = popElementFromParams('promoCode', search)
  const { fetchEvaluatedDiscount, data, status, error, isLoading } = useFetchEvaluatedDiscount()

  useEffect(() => {
    fetchEvaluatedDiscount({ storedDiscountCode: storedCode, searchDiscountCode: promoCodeFromParam })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps -- intentionally run once on mount; codes are read from stable storage/params at this point

  useEffect(() => {
    if (status === 'success' && data) {
      setDiscount(data)
      console.log('fetching data discount active preview: ', data)
      Storage.set(StorageKeys.PROMO_CODE, data.code)
    }
  }, [data, status])

  const refetchDiscountCode = () => fetchEvaluatedDiscount({ storedDiscountCode: storedCode, searchDiscountCode: promoCodeFromParam })

  return (
    <DiscountCodeContext.Provider
      value={{
        discount,
        isLoading,
        error,
        refetchDiscountCode,
      }}
    >
      {children}
    </DiscountCodeContext.Provider>
  )
}

export const useDiscountCode = () => {
  const context = useContext(DiscountCodeContext)
  if (!context) {
    throw new Error('useDiscountCode must be used within a DiscountCodeProvider')
  }
  return context
}
